<template>
  <div
    v-if="giftCardDesigns.length"
    class="cf-flex cf-flex--column cf-flex--gap-12"
  >
    <h3 class="cf-title cf-title--3 cf-text-align-left">
      Select A Design
    </h3>

    <div class="cf-gift-card-scroller">
      <!-- Left Scroll Button -->
      <button
        :class="['cf-gift-card-scroller__button cf-gift-card-scroller__button--previous', { 'cf-gift-card-scroller__button--hide': scrollAtStart }]"
        type="button"
        tabindex="-1"
        @click="handleScrollArrowClick('previous')"
      >
        <span class="cf-icon fa-chevron-left" />
      </button>

      <!-- Right Scroll Button -->
      <button
        :class="['cf-gift-card-scroller__button cf-gift-card-scroller__button--next', { 'cf-gift-card-scroller__button--hide': scrollAtEnd }]"
        type="button"
        tabindex="-1"
        @click="handleScrollArrowClick('next')"
      >
        <span class="cf-icon fa-chevron-right" />
      </button>

      <!-- Custom Gift Card Design Loop -->
      <div
        ref="cardScrollBar"
        class="cf-gift-card-scroller__items"
        @scroll="categoriesNavBarScrollHandler"
      >
        <cf-gift-card
          v-for="(cardDesign, idx) in giftCardDesigns"
          :key="idx"
          v-model="cardDesignId"
          type="radio-button"
          :card-design="cardDesign"
        />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfGiftCard from '@/view/components/globals/cf-gift-card/index.vue';


  export default {
    name: 'CfGiftCardDesignSelect',

    components: {
      CfGiftCard
    },

    props: {
      modelValue: {
        type: Number,
        default: null
      }
    },

    data() {
      return {
        scrollAtStart: true,
        scrollAtEnd: false,
        giftCardDesigns: []
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),

      cardDesignId: {
        get() {
          return this.modelValue;
        },

        set(value) {
          this.$emit('update:modelValue', value);
        }
      }
    },

    created() {
      this.giftCardDesigns = this.merchant.giftCardConfiguration.designs || [];
      this.cardDesignId = this.getDefaultSelectedGiftCard(this.giftCardDesigns);
    },

    methods: {
      async categoriesNavBarScrollHandler() {
        await this.$nextTick();

        const scroller = this.$refs.cardScrollBar;

        if (!scroller) {
          this.scrollAtStart = true;

          this.scrollAtEnd = true;
          return;
        }

        this.scrollAtStart = scroller.scrollLeft <= 0;
        this.scrollAtEnd = scroller.scrollWidth - scroller.scrollLeft <= scroller.clientWidth + 2;
      },

      handleScrollArrowClick(direction) {
        let distance = Math.ceil(this.$refs.cardScrollBar.clientWidth * 0.3);

        if (direction === 'previous') {
          distance *= -1;
        }

        this.$refs.cardScrollBar.scrollBy({
          left: distance,
          behavior: 'smooth'
        });
      },

      getDefaultSelectedGiftCard(giftCards) {
        const defaultGiftCard = giftCards.find(giftCard => giftCard.isDefault);

        return defaultGiftCard?.id || null;
      }
    }
  };
</script>

